import React from 'react';
import Container from 'react-bootstrap/Container';
import NavBar from '../components/navBar';
import Footer from '../components/footer';
import { constants } from '../content';
import {
  logoDarkImg,
  logoWhiteImg,
  facebookFooterImg,
  twitterFooterImg,
  instagramFooterImg,
  linkedinFooterImg,
  youtubeFooterImg,
  eBannerEU,
  greece20En,
  greece20El,
  usolveLogo
} from '../images';
import Greece20Article from "../components/greece20";

const Greece20 = () => {
  return (
  <>
    <NavBar
      image={logoDarkImg}
      optionsArray={constants.navBar}
    />
    <Container>
      <Greece20Article
        title={constants.coFinancedByGrEu.title}
        subtitle={constants.coFinancedByGrEu.subtitle}
        projectTitle={constants.coFinancedByGrEu.projectTitle}
        description={constants.coFinancedByGrEu.description}
        programme={constants.coFinancedByGrEu.programme}
        facts={constants.coFinancedByGrEu.facts}
        subtitleGr={constants.coFinancedByGrEu.subtitleGr}
        projectTitleGr={constants.coFinancedByGrEu.projectTitleGr}
        descriptionGr={constants.coFinancedByGrEu.descriptionGr}
        programmeGr={constants.coFinancedByGrEu.programmeGr}
        factsGr={constants.coFinancedByGrEu.factsGr}
        imageEN={greece20En}
        imageGR={greece20El}
        identityLink={constants.coFinancedByGrEu.identityLink}
        portalText={constants.coFinancedByGrEu.portalText}
        portalLink={constants.coFinancedByGrEu.portalLink}
      />
      <Footer
        image={logoWhiteImg}
        paragraph={constants.footer.paragraph}
        paragraphEU={constants.footer.paragraphEU}
        imageEU={eBannerEU}
        menuTitle={constants.footer.menuTitle}
        menuLinks={constants.footer.menuLinks}
        followTitle={constants.footer.followTitle}
        followLinks={constants.footer.followLinks}
        followImageArray={[facebookFooterImg, twitterFooterImg, instagramFooterImg, linkedinFooterImg, youtubeFooterImg]}
        contactTitle={constants.footer.contactTitle}
        contactLinks={constants.footer.contactLinks}
        copyright={constants.footer.copyright}
        privacyLinks={constants.footer.privacyLinks}
        termsLinks={constants.footer.termsLinks}
        coFinancedLinks={constants.coFinancedByGrEu.coFinancedLinks}
        usolveLogo={usolveLogo}
      />
    </Container>
  </>
)};

export default Greece20;
